/* ZOALIN_PDP_COLOR_MEDIA_SYNC_20260717 */
(() => {
  const COLOR_OPTION_RE = /colou?r|\u989c\u8272/i;
  const COLOR_TERMS = {
    black: ['black'],
    blue: ['blue'],
    blush: ['blush', 'pink'],
    navy: ['navy'],
    burgundy: ['burgundy', 'wine', 'red'],
    camel: ['camel', 'khaki'],
    khaki: ['khaki', 'camel'],
    pink: ['pink', 'blush'],
    sage: ['sage', 'green'],
  };

  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ');

  const SOFT_LAYERED_TARGETS = [
    [/camel|khaki/, 'zoalin soft layered modest set 10 camel lifestyle closeup 20260820'],
    [/blush|pink/, 'zoalin soft layered modest set 03 blush pink front studio final 20260820'],
    [/sage|green/, 'zoalin soft layered modest set 01 sage green front studio final 20260820'],
    [/black/, 'zoalin soft layered modest set 02 black front studio final 20260820'],
  ];

  const softLayeredTarget = (color) => {
    const normalized = normalize(color);
    if (!/soft-layered-modest-set/.test(window.location.pathname)) return '';
    const match = SOFT_LAYERED_TARGETS.find(([pattern]) => pattern.test(normalized));
    return match ? match[1] : '';
  };

  const termsFor = (color) => {
    const key = normalize(color);
    return COLOR_TERMS[key] || [key];
  };

  const getPickerColor = (picker) => {
    if (!picker) return '';

    const selectedInput = Array.from(picker.querySelectorAll('input[data-option-name]')).find((input) => {
      return COLOR_OPTION_RE.test(input.dataset.optionName || '') && (input.checked || input.dataset.currentChecked === 'true');
    });
    if (selectedInput?.value) return selectedInput.value;

    const selectedOption = Array.from(picker.querySelectorAll('select option:checked')).find((option) => {
      return COLOR_OPTION_RE.test(option.dataset.optionName || option.closest('select')?.name || '');
    });
    return selectedOption?.value || '';
  };

  const getScope = (picker) => picker?.closest('.shopify-section') || document;

  const slideText = (slide) => {
    const image = slide.querySelector('img');
    return [
      slide.getAttribute('data-zoalin-media-hint'),
      image?.alt,
      image?.currentSrc,
      image?.src,
      image?.srcset,
      image?.getAttribute('data-max-resolution'),
    ].join(' ');
  };

  const findColorSlideIndex = (gallery, color) => {
    const terms = termsFor(color).filter(Boolean);
    if (!terms.length) return -1;

    const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    const target = softLayeredTarget(color);
    if (target) {
      const exactIndex = slides.findIndex((slide) => normalize(slideText(slide)).includes(target));
      if (exactIndex >= 0) return exactIndex;
    }

    return slides.findIndex((slide) => {
      const text = normalize(slideText(slide));
      return terms.some((term) => text.includes(normalize(term)));
    });
  };

  const selectColorMedia = (color, picker) => {
    const gallery = getScope(picker).querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery || !color) return false;

    const slideshow = gallery.querySelector('slideshow-component');
    const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    const index = findColorSlideIndex(gallery, color);
    const slide = slides[index];
    if (index < 0 || !slide) return false;

    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(index, undefined, { animate: false });
    }

    const scroller = slide.closest('slideshow-slides');
    if (scroller) {
      scroller.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    }
    slide.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
    return true;
  };

  const scheduleColorMedia = (color, picker) => {
    if (!color) return;
    [0, 80, 220, 520, 900, 1600, 2600].forEach((delay) => {
      window.setTimeout(() => selectColorMedia(color, picker), delay);
    });
  };

  const initSelectedColorMedia = () => {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      scheduleColorMedia(getPickerColor(picker), picker);
    });
  };

  document.addEventListener('change', (event) => {
    const picker = event.target?.closest?.('variant-picker');
    if (!picker) return;

    const color = getPickerColor(picker);
    scheduleColorMedia(color, picker);
  });

  document.addEventListener('shopify:product:select', (event) => {
    const picker = event.target?.closest?.('variant-picker') || event.target;
    if (!picker?.matches?.('variant-picker')) return;

    const color = getPickerColor(picker);
    event.promise?.finally?.(() => scheduleColorMedia(color, picker));
    scheduleColorMedia(color, picker);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectedColorMedia);
  } else {
    initSelectedColorMedia();
  }
})();
